function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as fudouActiveApi from '@/api/fudouActiveApi.js';
import throttle from '@/utils/throttle';
import BindSelect from './BindSelect.vue';
import * as dangaoActApi from '@/api/dangaoActApi';
export default {
  components: {
    BindSelect: BindSelect
  },
  data: function data() {
    return {
      visibleDrawer: false,
      //是否为展开
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      initDetail: {},
      selectIds: [],
      selectLists: [],
      bindDetials: {}
    };
  },
  mounted: function mounted() {
    this.listData = {
      list: [],
      total: 0
    };
  },
  methods: _defineProperty(_defineProperty(_defineProperty({
    throttle: throttle,
    // 打开
    openInit: function openInit(row) {
      this.initDetail = row || {};
      this.handlerGetListData(this.listPram);
      this.visibleDrawer = true;
    },
    // 关闭
    closeDrawer: function closeDrawer() {
      this.visibleDrawer = false;
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      dangaoActApi.getcakeLists(_objectSpread(_objectSpread({}, pram), {}, {
        brandId: this.initDetail.brandId
      })).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 批量移除
    batchRemove: function batchRemove(removeIds) {
      var _this2 = this;
      this.$confirm('移除后数据不能被恢复，确认移除吗！', '确定移除').then(function (result) {
        dangaoActApi.removeBrandCakeBind({
          cakeIds: removeIds,
          brandId: _this2.initDetail.id
        }).then(function (data) {
          _this2.$message.success('删除数据成功');
          _this2.handlerGetListData(_this2.listPram);
          _this2.selectIds = [];
          _this2.selectLists = [];
        });
      });
    },
    addProducts: function addProducts() {
      var _this$$refs$BindSelec;
      (_this$$refs$BindSelec = this.$refs['BindSelectRef']) === null || _this$$refs$BindSelec === void 0 ? void 0 : _this$$refs$BindSelec.openInit(this.initDetail);
    }
  }, "closeDrawer", function closeDrawer() {
    this.visibleDrawer = false;
  }), "handleSelectionChange", function handleSelectionChange(selection) {
    this.selectIds = selection.map(function (item) {
      return item.productId;
    });
    this.selectLists = selection || [];
  }), "beforeUpload", function beforeUpload(file) {
    var _this3 = this;
    var formData = new FormData();
    formData.append('file', file);
    dangaoActApi.importBrandCakeBind(formData, this.initDetail.id).then(function (res) {
      _this3.$message.success('导入成功！');
      _this3.visible = false;
      _this3.handerSearch();
    });
  })
};